import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageContainer from "../routes/PageContainer";
import unAnthenticatedRoutes from "../routes/subRoutes/unAnthenticatedRoutes";
import geriactiveRoutes from "../routes/subRoutes/GeriactiveRoutes";
import administratorRoutes from "../routes/subRoutes/administrationRoutes";
import plmRoutes from "../routes/subRoutes/plmRoutes";
import { urls } from "../utils/urls";
import { makeGetRequest } from "../utils/api";
import { useDispatch } from "react-redux";
import { logout, userAccessLevel } from "../store/slices/user";
import { hasPermission } from "../utils/permissions";

function AuthenticationPortal(props) {
  // resolvedPermissions is rehydrated from localStorage when the store is
  // created, so a refresh renders the right routes on the first paint. The
  // lookup below then revalidates it in the background.
  const { authenticated, permissions, resolvedPermissions } = useSelector(
    (state) => state.user
  );

  const dispatch = useDispatch();

  useEffect(() => {
    props.setToken(authenticated);
  }, [authenticated]);

  const user_permissions = JSON.parse(localStorage.getItem("permissions"));

  const handlePermissions = async () => {
    if (!authenticated) {
      return;
    }
    const response = await makeGetRequest(
      urls.permissionLookup + "?permissions=" + user_permissions,
      "",
      true
    );
    if (response.status !== 200) {
      dispatch(logout());
      window.location.reload();
      return;
    }
    // Published so NavBar can read them instead of fetching them again, and
    // cached so the next refresh does not have to wait for this request.
    dispatch(userAccessLevel({ resolvedPermissions: response.data }));
  };

  useEffect(() => {
    handlePermissions();
  }, [permissions]);

  // Derived during render rather than held in state. Storing route elements in
  // state made every refresh paint in three stages: nothing, then chrome with an
  // empty outlet, then content.
  const routesForUser = () => {
    if (!resolvedPermissions) {
      return [];
    }
    // PLM is a replacement view, not an addition: a user holding both PLM and
    // GeriActive gets the PLM routes only.
    const routes = hasPermission(resolvedPermissions, "PLM")
      ? [...plmRoutes]
      : [...geriactiveRoutes];
    if (hasPermission(resolvedPermissions, "GeriActiveAdministrativeAccount")) {
      routes.push(...administratorRoutes);
    }
    return routes;
  };

  return (
    <BrowserRouter>
      <Routes>
        {authenticated ? (
          <Route path="/" element={<PageContainer />}>
            {routesForUser()}
          </Route>
        ) : (
          unAnthenticatedRoutes
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default AuthenticationPortal;
